"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _unleashProxyClient = require("unleash-proxy-client");
var _ravenJs = _interopRequireDefault(require("raven-js"));
var _queryString = _interopRequireDefault(require("query-string"));
var _mobx = require("mobx");
var _config = _interopRequireDefault(require("../config"));
var _head = _interopRequireDefault(require("lodash/head"));
var _find = _interopRequireDefault(require("lodash/find"));
var _includes = _interopRequireDefault(require("lodash/includes"));
var _constants = require("../constants");
var _queries = require("../api/platform/queries");
var _authentication = require("../utils/authentication");
var _enums = require("../enums");
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var BasePlatformStore = (_dec = _mobx.observable.ref, (_class = /*#__PURE__*/_createClass(function BasePlatformStore() {
  var _this = this;
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
  _classCallCheck(this, BasePlatformStore);
  _initializerDefineProperty(this, "developmentFeatureFlags", _descriptor, this);
  _initializerDefineProperty(this, "isContentProtected", _descriptor2, this);
  _initializerDefineProperty(this, "canAnswerSurveyQuestions", _descriptor3, this);
  _initializerDefineProperty(this, "canUseMediaInStepHints", _descriptor4, this);
  _initializerDefineProperty(this, "sso", _descriptor5, this);
  _initializerDefineProperty(this, "showStepNoteIconLabel", _descriptor6, this);
  _initializerDefineProperty(this, "canUseXmReality", _descriptor7, this);
  _initializerDefineProperty(this, "hasFeedbackEnabled", _descriptor8, this);
  _initializerDefineProperty(this, "hasChecklistsEnabled", _descriptor9, this);
  _initializerDefineProperty(this, "hasChecklistsSignatureEnabled", _descriptor10, this);
  _initializerDefineProperty(this, "translations", _descriptor11, this);
  _initializerDefineProperty(this, "availableLanguagesDetails", _descriptor12, this);
  _initializerDefineProperty(this, "xMRealityTeamForDomain", _descriptor13, this);
  _initializerDefineProperty(this, "domain", _descriptor14, this);
  _initializerDefineProperty(this, "hasChecklistEscalation", _descriptor15, this);
  _initializerDefineProperty(this, "loaded", _descriptor16, this);
  _initializerDefineProperty(this, "hasAiStepContentSuggestions", _descriptor17, this);
  _initializerDefineProperty(this, "hasApiAccess", _descriptor18, this);
  _initializerDefineProperty(this, "hasDispatchSite", _descriptor19, this);
  _initializerDefineProperty(this, "hasDispatchEnabled", _descriptor20, this);
  _initializerDefineProperty(this, "hasDispatchDocumentsSyncEnabled", _descriptor21, this);
  _initializerDefineProperty(this, "setLoaded", _descriptor22, this);
  _initializerDefineProperty(this, "setAvailableLanguagesDetails", _descriptor23, this);
  // subdomain from the platform db, which will be the platform slug
  _defineProperty(this, "setPlatformSlug", function (subdomain) {
    return _this.platformSlug = subdomain;
  });
  _defineProperty(this, "setDefaultDomainSlug", function (domain) {
    return _this.defaultDomainSlug = domain && domain.slug;
  });
  _defineProperty(this, "getLocalMapping", function (browserLocale) {
    var cleanLocale = browserLocale && browserLocale.substring(0, 2);
    if (_config["default"].availableLanguages.includes(cleanLocale)) {
      return cleanLocale;
    }
    return _constants.DEFAULT_LOCALE.substring(0, 2);
  });
  _defineProperty(this, "getNavigatorLanguage", function () {
    return window.navigator.languages ? window.navigator.languages[0] : window.navigator.language || window.navigator.userLanguage;
  });
  _defineProperty(this, "setLocaleStrings", function () {
    var langFromStorage = localStorage.getItem(_constants.LOCAL_STORAGE_KEY_LANGUAGE);
    _this.browserLocale = window.location && _queryString["default"].parse(window.location.search, {
      arrayFormat: 'bracket'
    }).locale || langFromStorage || _this.navigatorLanguage || _constants.DEFAULT_LOCALE;
  });
  _defineProperty(this, "getActionWhenLoggedInOptionNotAllowed", function (reason) {
    var loggedInUserOptions = reason.loggedInUserOptions,
      supportedLoginOptions = reason.supportedLoginOptions;
    var actionsMap = [{
      condition: !(0, _includes["default"])(loggedInUserOptions, 'SSO') && (0, _authentication.isSsoOnlyAllowedDomainLoginOption)(supportedLoginOptions),
      action: _enums.DOMAIN_LOGIN_FORBIDDEN_ACTIONS.SHOW_SSO_DIALOG
    }, {
      condition: true,
      action: _enums.DOMAIN_LOGIN_FORBIDDEN_ACTIONS.REDIRECT_AND_LOGOUT
    }];
    return (0, _find["default"])(actionsMap, 'condition').action;
  });
  _defineProperty(this, "fetchAvailableLanguages", function () {
    _axios["default"].post('/graphql', {
      query: _queries.AvailableLanguages.loc.source.body
    }).then(function (_ref) {
      var data = _ref.data.data;
      var langFromStorage = localStorage.getItem(_constants.LOCAL_STORAGE_KEY_LANGUAGE);
      var preferredLocale = _queryString["default"].parse(window.location.search, {
        arrayFormat: 'bracket'
      }).locale || langFromStorage || _this.navigatorLanguage || _constants.DEFAULT_LOCALE;
      var languageMatchingLocal = function languageMatchingLocal(lang) {
        return lang.locale.includes(preferredLocale.replace('-', '_'));
      };
      var languageMatchingLocalShort = function languageMatchingLocalShort(lang) {
        return lang.locale.includes(preferredLocale.substring(0, 2));
      };
      var currentLanguage = data && data.availableLanguages && (data.availableLanguages.find(languageMatchingLocal) || data.availableLanguages.find(languageMatchingLocalShort) || (0, _head["default"])(data.availableLanguages));
      if (!langFromStorage) {
        _this.setLanguage(currentLanguage.locale);
      }
      _this.setCurrentLanguage(currentLanguage.locale);
      _this.setAvailablelanguages(data.availableLanguages);
    });
  });
  _defineProperty(this, "fetchPlatformFlags", function () {
    return _axios["default"].post(_constants.GRAPHQL_URL, {
      query: _queries.PlatformFlags.loc.source.body
    }).then(function (_ref2) {
      var data = _ref2.data.data;
      var platform = data.platform;
      var isContentProtected = platform.isContentProtected,
        canAnswerSurveyQuestions = platform.canAnswerSurveyQuestions,
        canUseMediaInStepHints = platform.canUseMediaInStepHints,
        sso = platform.sso,
        enforceAdminSSO = platform.enforceAdminSSO,
        canUseXmReality = platform.canUseXmReality,
        hasFeedbackEnabled = platform.hasFeedbackEnabled,
        hasChecklistsEnabled = platform.hasChecklistsEnabled,
        hasChecklistsSignatureEnabled = platform.hasChecklistsSignatureEnabled,
        hasRever = platform.hasRever,
        domain = platform.domain,
        hasChecklistEscalation = platform.hasChecklistEscalation,
        hasApiAccess = platform.hasApiAccess,
        hasDispatchSite = platform.domain.hasDispatchSite,
        hasDispatchEnabled = platform.hasDispatchEnabled;
      _this.setPlatformFlags({
        isContentProtected: isContentProtected,
        canAnswerSurveyQuestions: canAnswerSurveyQuestions,
        canUseMediaInStepHints: canUseMediaInStepHints,
        sso: sso,
        enforceAdminSSO: enforceAdminSSO,
        canUseXmReality: canUseXmReality,
        hasFeedbackEnabled: hasFeedbackEnabled,
        hasChecklistsEnabled: hasChecklistsEnabled,
        hasChecklistsSignatureEnabled: hasChecklistsSignatureEnabled,
        hasRever: hasRever,
        domain: domain,
        hasChecklistEscalation: hasChecklistEscalation,
        hasApiAccess: hasApiAccess,
        hasDispatchSite: hasDispatchSite,
        hasDispatchEnabled: hasDispatchEnabled
      });
      _this.setLoaded(true);
    });
  });
  _initializerDefineProperty(this, "setPlatformFlags", _descriptor24, this);
  _defineProperty(this, "fetchDevelopmentFeatureFlags", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var data, formatToggles, allToggles, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          formatToggles = function formatToggles(toggles) {
            return toggles.reduce(function (acc, toggle) {
              acc[toggle.name] = toggle.enabled;
              return acc;
            }, {});
          };
          _context.prev = 1;
          if (!_this.isUnleashEnabled) {
            _context.next = 12;
            break;
          }
          _context.next = 5;
          return _this.unleashProxyClient.start();
        case 5:
          _context.next = 7;
          return _this.unleashProxyClient.getAllToggles();
        case 7:
          allToggles = _context.sent;
          // Default to bootstrap flags if unleash is reachable but no feature toggles are available
          if (allToggles.length < 1) {
            allToggles = _constants.UNLEASH_BOOTSTRAP_DEV_FEATURE_FLAGS;
          }
          data = formatToggles(allToggles);
          _context.next = 16;
          break;
        case 12:
          _context.next = 14;
          return _axios["default"].get(_constants.FEATURE_FLAGS_API_URL);
        case 14:
          response = _context.sent;
          data = response.data;
        case 16:
          _context.next = 22;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](1);
          data = formatToggles(_constants.UNLEASH_BOOTSTRAP_DEV_FEATURE_FLAGS);
          _ravenJs["default"].captureException(new Error('Could not fetch development feature flags from Unleash server'));
        case 22:
          _this.setDevelopmentFeatureFlags(data);
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 18]]);
  })));
  _initializerDefineProperty(this, "setDevelopmentFeatureFlags", _descriptor25, this);
  _defineProperty(this, "getLanguage", function () {
    return _this.currentLanguage;
  });
  _defineProperty(this, "setLocalLanguage", function (language) {
    localStorage.setItem(_constants.LOCAL_STORAGE_KEY_LANGUAGE, language);
  });
  _defineProperty(this, "setLanguage", function (language) {
    _this.setLocalLanguage(language);
    window.location = _this.getLocationWithoutLocale();
  });
  _defineProperty(this, "setOrganization", function (organization) {
    return _this.organization = organization;
  });
  _defineProperty(this, "setXmRealityTeamForDomain", function (domain) {
    var xMRealityTeam = domain.xMRealityTeam;
    return _this.xMRealityTeamForDomain = xMRealityTeam;
  });
  _defineProperty(this, "getOrganization", function () {
    return _this.organization;
  });
  _defineProperty(this, "setOrganizationName", function (name) {
    return _this.organizationName = name;
  });
  _defineProperty(this, "getLocationWithoutLocale", function () {
    var filtered = _queryString["default"].stringify(_objectSpread(_objectSpread({}, _queryString["default"].parse(window.location.search)), {
      locale: undefined
    }));
    var base = window.location.href.split('?')[0];
    return filtered ? "".concat(base, "?").concat(filtered) : base;
  });
  _defineProperty(this, "setStore", function (store) {
    return _this.store = store;
  });
  _initializerDefineProperty(this, "setTranslations", _descriptor26, this);
  _defineProperty(this, "handleGoesOffline", function () {
    var addNotification = _this.store.toastNotifications.addNotification;
    addNotification({
      message: _this.translations.goesOffline,
      type: _enums.TOAST_NOTIFICATIONS_TYPES.ERROR
    });
  });
  _defineProperty(this, "handleGoesBackOnline", function () {
    var addNotification = _this.store.toastNotifications.addNotification;
    addNotification({
      message: _this.translations.goesBackOnline,
      type: _enums.TOAST_NOTIFICATIONS_TYPES.SUCCESS
    });
  });
  _defineProperty(this, "addOnlineStatusListener", function () {
    window.addEventListener('offline', _this.handleGoesOffline);
    window.addEventListener('online', _this.handleGoesBackOnline);
  });
  (0, _mobx.makeObservable)(this);
  this.hostname = hostname;
  this.platformSlug = '';
  this.defaultDomainSlug = '';
  this.navigatorLanguage = this.getNavigatorLanguage();
  this.setLocaleStrings();
  this.translations = {};
  this.isUnleashEnabled = String(_constants.UNLEASH_ENABLED).toLowerCase() === 'true';
  if (this.isUnleashEnabled) {
    this.unleashProxyClient = new _unleashProxyClient.UnleashClient({
      url: _constants.UNLEASH_URL,
      clientKey: _constants.UNLEASH_CLIENT_KEY,
      appName: _constants.UNLEASH_APP_NAME,
      context: {
        hostname: hostname,
        environment: _constants.NODE_ENV
      },
      bootstrapOverride: true,
      bootstrap: _constants.UNLEASH_BOOTSTRAP_DEV_FEATURE_FLAGS
    });
    this.unleashProxyClient.on('error', function (error) {
      return _ravenJs["default"].captureException(error);
    });
    this.unleashProxyClient.on('warn', function (warning) {
      return _ravenJs["default"].captureMessage(warning);
    });
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "developmentFeatureFlags", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isContentProtected", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canAnswerSurveyQuestions", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canUseMediaInStepHints", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sso", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showStepNoteIconLabel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "canUseXmReality", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hasFeedbackEnabled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasChecklistsEnabled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "hasChecklistsSignatureEnabled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "translations", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "availableLanguagesDetails", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "xMRealityTeamForDomain", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "domain", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "hasChecklistEscalation", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "loaded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "hasAiStepContentSuggestions", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "hasApiAccess", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "hasDispatchSite", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "hasDispatchEnabled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "hasDispatchDocumentsSyncEnabled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "setLoaded", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (loaded) {
      return _this2.loaded = loaded;
    };
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "setAvailableLanguagesDetails", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (availableLanguagesDetails) {
      _this3.availableLanguagesDetails = availableLanguagesDetails;
    };
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "setPlatformFlags", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (_ref4) {
      var isContentProtected = _ref4.isContentProtected,
        canManageCampaigns = _ref4.canManageCampaigns,
        hasMultiDomainEnabled = _ref4.hasMultiDomainEnabled,
        canColorContent = _ref4.canColorContent,
        canUseMediaInStepHints = _ref4.canUseMediaInStepHints,
        canUseBasicAnalytics = _ref4.canUseBasicAnalytics,
        canUseCustomFonts = _ref4.canUseCustomFonts,
        canUseLiveChat = _ref4.canUseLiveChat,
        sso = _ref4.sso,
        enforceAdminSSO = _ref4.enforceAdminSSO,
        guideApproval = _ref4.guideApproval,
        name = _ref4.name,
        canExportToPdf = _ref4.canExportToPdf,
        hasFeedbackEnabled = _ref4.hasFeedbackEnabled,
        hasBeekeeperIntegrationEnabled = _ref4.hasBeekeeperIntegrationEnabled,
        hasChecklistsEnabled = _ref4.hasChecklistsEnabled,
        hasChecklistsSignatureEnabled = _ref4.hasChecklistsSignatureEnabled,
        canUseXmReality = _ref4.canUseXmReality,
        canUseAutoTranslations = _ref4.canUseAutoTranslations,
        hasNativeApp = _ref4.hasNativeApp,
        nativeAppAutoRemovalInterval = _ref4.nativeAppAutoRemovalInterval,
        hasChecklistEscalation = _ref4.hasChecklistEscalation,
        canAnswerSurveyQuestions = _ref4.canAnswerSurveyQuestions,
        domain = _ref4.domain,
        hasAiStepContentSuggestions = _ref4.hasAiStepContentSuggestions,
        hasSkillsEnabled = _ref4.hasSkillsEnabled,
        hasConfigurableAlertsRecipients = _ref4.hasConfigurableAlertsRecipients,
        hasApiAccess = _ref4.hasApiAccess,
        hasDispatchSite = _ref4.hasDispatchSite,
        hasDispatchEnabled = _ref4.hasDispatchEnabled,
        hasDispatchDocumentsSyncEnabled = _ref4.hasDispatchDocumentsSyncEnabled;
      _this4.isContentProtected = isContentProtected;
      _this4.canManageCampaigns = canManageCampaigns;
      _this4.hasMultiDomainEnabled = hasMultiDomainEnabled;
      _this4.canColorContent = canColorContent;
      _this4.canUseMediaInStepHints = canUseMediaInStepHints;
      _this4.canUseBasicAnalytics = canUseBasicAnalytics;
      _this4.canUseCustomFonts = canUseCustomFonts;
      _this4.canUseLiveChat = canUseLiveChat;
      _this4.sso = sso;
      _this4.enforceAdminSSO = enforceAdminSSO;
      _this4.guideApproval = guideApproval;
      _this4.name = name;
      _this4.canExportToPdf = canExportToPdf;
      _this4.hasFeedbackEnabled = hasFeedbackEnabled;
      _this4.hasBeekeeperIntegrationEnabled = hasBeekeeperIntegrationEnabled;
      _this4.hasChecklistsEnabled = hasChecklistsEnabled;
      _this4.hasChecklistsSignatureEnabled = hasChecklistsSignatureEnabled;
      _this4.canUseXmReality = canUseXmReality;
      _this4.canUseAutoTranslations = canUseAutoTranslations;
      _this4.hasNativeApp = hasNativeApp;
      _this4.nativeAppAutoRemovalInterval = nativeAppAutoRemovalInterval;
      _this4.hasChecklistEscalation = hasChecklistEscalation;
      _this4.hasSkillsEnabled = hasSkillsEnabled;
      _this4.hasConfigurableAlertsRecipients = hasConfigurableAlertsRecipients;
      _this4.canAnswerSurveyQuestions = canAnswerSurveyQuestions;
      _this4.domain = domain;
      _this4.hasAiStepContentSuggestions = hasAiStepContentSuggestions;
      _this4.hasApiAccess = hasApiAccess;
      _this4.hasDispatchSite = hasDispatchSite;
      _this4.hasDispatchEnabled = hasDispatchEnabled;
      _this4.hasDispatchDocumentsSyncEnabled = hasDispatchDocumentsSyncEnabled;
    };
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "setDevelopmentFeatureFlags", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (data) {
      _this5.developmentFeatureFlags = data;
    };
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "setTranslations", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (translations) {
      return _this6.translations = translations;
    };
  }
})), _class));
var _default = exports["default"] = BasePlatformStore;
//# sourceMappingURL=platform.js.map